module.exports = __webpack_public_path__ + "img/c00_buildingtechsaddlebags_Normal_ua.bf43b148.webp";